import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import SearchBar from '../components/SearchBar';
import { getCities } from '../services/locationService';
import { createSlug } from '../utils/url';

const popularCities = [34, 6, 35, 16, 7]; // İstanbul, Ankara, İzmir, Bursa, Antalya

export default function Cities() {
  const navigate = useNavigate();
  const [cities, setCities] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadCities();
  }, []);

  const loadCities = async () => {
    try {
      const data = await getCities();
      setCities(data);
    } catch (err) {
      setError('Şehirler yüklenirken bir hata oluştu.');
      console.error('Error loading cities:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCityClick = (cityName: string) => {
    navigate(`/il/${createSlug(cityName)}`);
  };

  const filteredCities = cities.filter(city => 
    city.name.toLocaleLowerCase('tr').includes(search.toLocaleLowerCase('tr'))
  );

  const popularCityItems = cities
    .filter(city => popularCities.includes(city.plate_number))
    .map(city => ({
      id: city.id,
      name: city.name
    }));

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <div className="animate-pulse space-y-4">
            <div className="h-12 bg-[#24272e] rounded-lg w-1/3"></div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {[...Array(15)].map((_, i) => (
                <div key={i} className="h-20 bg-[#24272e] rounded-lg"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <div className="bg-[#24272e] rounded-2xl p-4 sm:p-6 md:p-8 border border-white/10">
          <div className="flex flex-col gap-4 mb-6 sm:mb-8">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-2xl shadow-lg shadow-yellow-400/20">
                <Building2 className="w-8 h-8 text-black" />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-white">Şehirler</h1>
                <p className="text-sm text-white/60">Size en yakın taksi durağını bulun</p>
              </div>
            </div>
            
            <SearchBar 
              placeholder="Şehir ara..."
              onChange={setSearch}
              popularItems={popularCityItems}
              onItemClick={(id) => {
                const city = cities.find(c => c.id === id);
                if (city) handleCityClick(city.name);
              }}
            />
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-3">
            {filteredCities.map(city => (
              <button
                key={city.id}
                onClick={() => handleCityClick(city.name)}
                className="group relative bg-[#1a1d24] hover:bg-[#2d3039] p-3 sm:p-4 rounded-xl transition-all duration-300"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/0 to-yellow-400/0 group-hover:from-yellow-400/5 group-hover:to-yellow-400/0 rounded-xl transition-all duration-300" />
                <p className="relative text-sm sm:text-base font-medium text-white group-hover:text-yellow-400 transition-colors">
                  {city.name}
                </p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}